import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { toDataSourceRequestString } from '@progress/kendo-data-query';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useParams, withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { snackbarMessage } from '../core/actions';
import { createRequest, requestApi } from '../core/controls/helpers/rest';
import Card from '../core/modules/corn_generator/lib/card';
import { getEnvVariable } from '../modules/environmentalList';
import { GenerateInvoice, GetDomainValues,
    GetPaymentInformation, GetRecordDataByKeys, GetRecordInvoiceByType, GetSitePermitType,GetBillingSitePermitType,
     GetTotalDue, GetTotalFee, ReGenerateInvoice, UpdateInvoiceStatus, RequestPayOnline, GetInvoiceLineItemsByInvoiceId } from './billingservice';
//import BillingSidepopup from '../billing/billingsidepopup'
//import BillingRegenerate from '../billing/billingregenerate'
import InvoiceSideBar from './billinginvoice';
import RegenerateSideBar from './billingregenerateoptions';
import { IsValidInvoiceStatus, IsValidPermitStatus } from './statusvalidator';

import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import PaymentIcon from '@material-ui/icons/Payment';
import SaveIcon from '@material-ui/icons/Save';
import DefaultSettings from '../core/controls/components/settings';
import TextBox from '../core/controls/components/textbox';
import { GetData } from '../core/controls/helpers/requests';
import BillingGrid from './billinggrid';
import PhysicalCheckSideBar from './billingphysicalcheck';
import { AppBar } from '@material-ui/core';
import Dropdown from '../core/controls/components/dropdown';
import MSBCheckout from './onlinepay/msbcheckout';

const _ = require('lodash');

const headerProps = {
    hassidebartabs: true,
    components: [
        {
            type: 'breadcrumbs',
            items: [
                {
                    "link": "Record", href: {
                        "routes": [
                            {
                                "route": "#/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },
                        ],
                    }, menuhref: {
                        "routes": [
                            {
                                "route": "/Records",
                                "routeParams": "key",
                            },
                            {
                                "route": "",
                                "routeParams": "routeid"
                            },
                            {
                                "route": "",
                                "routeParams": "routeid1"
                            },

                        ],
                    }, className: 'eps-breadcrumb-item', "materialicon": "assignment", class: 'text-light'
                },
                { "link": "Billing", appendval: 'Name', "materialicon": "local_atm", className: 'eps-breadcrumb-item ', class: 'text-light' }
            ],
        }
    ],
    extracomponents: [{ label: "Permit Number", value: "PERMIT_NO" }],
    extraactions: [
        {
            type: 'icon',
            icon: 'back',
            name: 'back',
            hideon: 'back',
            hidevalue: false,
            title: 'Back',
            menucolor: '#924fe3'
        },
    ],

}
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {/* by removing style scrollbar will be hided {value === index && <Box p={3} style={{ overflow: 'auto', height: '800px' }}>{children}</Box>} */}
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        "& .MuiTab-root": {
            'text-transform': 'capitalize'
        },
    },
    firstIcon: {
        paddingLeft: 70
    },
    labelContainer: {
        width: "auto",
        padding: 0
        // padding: '20px'
    },
    iconLabelWrapper: {
        flexDirection: "row",
        padding: 0
        // padding: '20px'
    },
}));

function Billing(props) {
    // const { headerProps } = props.options
    const [data, setData] = useState([])
    const [total, setTotal] = useState(0)
    const [gridColumns, setGridColumns] = useState([])
    const [LineItemsdata, setLineItemsdata] = useState([])
    // const [attachmentTypeResults, setAttachmentTypeResults] = useState(null)
    const [TabValue, setTabValue] = useState(0)
    const [invoice, setInvoice] = useState({})
    const [transinvoice, setTransInvoice] = useState(null)
    const [transinvoiceitems, setTransInvoiceitems] = useState({})
    const [pdf, setPDF] = useState(null)
    const [openInvoice, setOpenInvoice] = useState(false)
    const [currentDataItem, setCurrentDataItem] = useState(null)
    const [openSlide, setOpenSlide] = useState(false)
    const [generateInvoiceType, setGenerateInvoiceType] = useState(null)
    const [openGenerateInvoice, setOpenGenerateInvoice] = useState(false)

    const [permitDropdown, setPermitDropdown] = useState([])
    const [appDropdown, setAppDropdown] = useState([])
    const [paymentStatusOptions, setPaymentStatusOptions] = useState([])
    const [paymentStatusValue, setPaymentStatusValue] = useState(null)
    const [initialloadextrainfo, setInitialloadextrainfo] = useState(null)
    const [cashcontrolnumber, setcashcontrolnumber] = useState(null)
    //const [components, setComponents] = useState({ ...BillingSidepopup })
    const [dataState, setDataState] = useState({
        skip: 0, take: 5
    })
    const [EachComp, setEachComp] = useState(null)
    const [pageable, setPageable] = useState({
        buttonCount: 6,
        info: true,
        type: 'numeric',
        pageSizes: [10, 20, 30, 40, 50, "all"],
        previousNext: true
    })
    const helpContext = useRef(null);
    const silderContext = useRef(null);
    const [gridSelectionRecord, setGridSelectionRecord] = useState(false)
    const [hascheckbox, setHasCheckBox] = useState(false)
    const [gridCheckBoxSelectionRecords, setGridCheckBoxSelectionRecords] = useState([])
    const [sitePermitTypeData, setSitePermitTypeData] = useState(null)
    const [billingsitePermitTypeData, setbillingSitePermitTypeData] = useState(null)
    const [physicalCheck, setPhysicalCheck] = useState(false)
    const [physicalCheckProps, setPhysicalCheckProps] = useState({ open: false, type: 'NEW', id: 0 })
    const [recordDetails, setRecordDetails] = useState({});
    const params = useParams();
    const classes = useStyles();
    const[openMSBPay, setOpenMSBPay] = useState(false);

    useEffect(() => {
        let recorddatakeys = ["COMPANY_ID", "PERMIT_TYPE_ID", "APPLICATION_STATUS", "SITE_PERMIT_TYPE_ID", "PERMIT_NO",
            "DISTRICT_ID", "COUNTY", "AUTHORIZED_DATE", "AUTHORIZED_BY", "PERMIT_NO", "EXEMPTED_FROM_RENEWAL", "EXEMPTED_FROM_PRORATE"]
        Promise.all([
            GetRecordDataByKeys(props.match.params.routeid, props.match.params.routeid1, recorddatakeys),
            GetSitePermitType(props.match.params.routeid),
            GetDomainValues('APPLICATION_PAYMENT_STATUS'),
            GetDomainValues('PERMIT_PAYMENT_STATUS'),
            GetBillingSitePermitType(props.match.params.routeid)
        ]).then((values) => {
            //const { recorddetails, sitepermittypedetails, apppaymentstatus, permitpaymentstatus} = values;
            //console.log(recorddetails, sitepermittypedetails, apppaymentstatus, permitpaymentstatus);
            if (values && Array.isArray(values)) {
                let recorddetails = values[0];
                let sitepermittypedetails = values[1];
                let apppaymentstatus = values[2];
                let permitpaymentstatus = values[3];
                let billingitepermittypedetails = values[4];
                let fullrecorddetails = recorddetails[0];
                fullrecorddetails["KEY"] = props.match.params.key;
                let initialloadextrainfodata = { results: values[0][0] }
                setInitialloadextrainfo(initialloadextrainfodata);
                setRecordDetails(fullrecorddetails);
                let tabid = props.history.location.pathname.split('billings/')
                let tid = tabid[1]
                if(tid){
                    props.history.push(tabid[0]+'billings')
                }else{
                    props.history.push(tabid[0])
                }
                //props.history.push(tabid[0])
                let initialtabvalue = tid ? tid : billingitepermittypedetails && billingitepermittypedetails.HasApplicationFee && billingitepermittypedetails.HasApplicationFee === "Y" ? "0" : billingitepermittypedetails.HasPorate && billingitepermittypedetails.HasPorate === "Y" ? "1" : billingitepermittypedetails.PermitRenewal && billingitepermittypedetails.PermitRenewal === "Y" ? "2" : "3"

                setTabValue(initialtabvalue);
                setSitePermitTypeData(sitepermittypedetails);
                setbillingSitePermitTypeData(billingitepermittypedetails);

                setAppDropdown(apppaymentstatus);
                setPaymentStatusOptions(apppaymentstatus);

                setPermitDropdown(permitpaymentstatus);
            }
            console.log(values);
        });
        //LoadExistingInvoiceData()
        LoadData();
    }, [])

    const LoadExistingInvoiceData = () => {
        if (TabValue < 4) {
            LoadInvoiceDetails();
        }
        if (TabValue === "4" || TabValue === 4) {
            LoadPaymentInformation();
        }
    }

    const LoadInvoiceDetails = () => {
        let url = getEnvVariable('Admin') + `/api/Domains/values?domainkey=TRANSACTION_INVOICE_STATUS`;
        //console.log('Loading from ------------------------------------------------------*******')
        let invoicetypeexp = (TabValue === 0 || TabValue === '0') ? "APPLICATION" : (TabValue === 1 || TabValue === '1') ? 'Prorate' : (TabValue == 3 || TabValue == '3') ? 'All' : 'PermitRenewal';
        GetRecordInvoiceByType(props.match.params.routeid1, invoicetypeexp).then(invres => {
            let extdata = []; //[...data, ...invres.InvoiceLineItems];
            let statusopts = TabValue < 2 ? appDropdown : permitDropdown
            if (invres && Array.isArray(invres) && invres.length > 0) {
                if (TabValue < 3) {
                    let proinvoice = invres.filter(a => (a.InvoiceType === invoicetypeexp || a.InvoiceType === 'Application') && a.Status != "C")
                    if (proinvoice.length > 0) {
                        proinvoice = proinvoice.sort(function (a, b) {
                            return b.Id - a.Id;
                        });
                        extdata = proinvoice[0].InvoiceDetails
                        setData(extdata)
                        setInvoice(proinvoice[0])
                        setcashcontrolnumber(proinvoice[0].InvoiceDetails[0].Invoice.CashControlNumber)
                        setTransInvoice(proinvoice[0].InvoiceDetails[0].Invoice.TransactionStatus)
                        setPaymentStatusOptions(statusopts)
                        setGridSelectionRecord(null)
                        LoadInvoiceLineItems(proinvoice[0].Id) 
                    } else {
                        setData([])
                        setLineItemsdata([])
                        //setInvoice({})
                        setInvoice({})
                        // GetBaseRecordDetail(props.match.params.routeid1).then(res => {
                        //     let invoice = {PermitNumber: res.PermitNo}
                        //     setInvoice(invoice)
                        // })
                    }
                } else {
                    // let invdataarr = invres.filter(a => a.InvoiceType === 'PermitRenewal');
                    // if (invdataarr && Array.isArray(invdataarr)) {
                    //     invdataarr.forEach(element => {
                    //         element.InvoiceLineItems = element.InvoiceLineItems.length;
                    //         element.InvoiceDetails = element.InvoiceDetails.length;
                    //     });
                    // }

                    setData(invres)
                   // setInvoice(invdataarr[0])
                    setPaymentStatusOptions(statusopts)
                    setGridSelectionRecord(null)
                }
            } else {
                setInvoice({})
                setLineItemsdata([])
            }
        })
        GetData(url, '', true).then(resp => {
            if (resp) {
                setTransInvoiceitems(resp);
            }

        })
    }

    const LoadPaymentInformation = () => {
        GetPaymentInformation(props.match.params.routeid1).then(invres => {
            console.log(invres)
            if (invres && Array.isArray(invres)) {
                setData(invres);
                setInvoice({});
                setPaymentStatusOptions([]);
                setGridSelectionRecord(null);
            }
        })
    }

    const LoadInvoiceLineItems = (invoiceid) => {
        GetInvoiceLineItemsByInvoiceId(invoiceid).then(invres => {
            console.log(invres)
            if (invres && Array.isArray(invres)) {
                setLineItemsdata(invres); 
            }
        })
    }

    useEffect(() => {
        LoadData();
    }, [dataState])

    const LoadData = () => {
        const queryStr = `${toDataSourceRequestString(dataState)}`;
        //we do request grid request and need to  append queryStr for url
        let dataitems = (TabValue == "0" || TabValue == "2") ? LineItemsdata : data || []
        //setData(dataitems);
        setTotal(dataitems.length);
        //for getting distinct columns, returns all distinct columns by verifying all objects in data array
        let columnsarr = _.union(_.flatten(_.map(dataitems, (e) => _.keys(e))));
        var removedfields = _.remove(columnsarr, function (n) {
            if (TabValue < 3)
                return n != "UpdatedBy" && n != "UpdatedOn" && n != "Id" && n != "BillingPayments" && n != "DownloadId" && n != "CreatedBy" && n != "CreatedOn";
            else
                return n != "UpdatedBy" && n != "UpdatedOn" && n != "BillingPayments" && n != "DownloadId" && n != "CreatedBy" && n != "CreatedOn";
        });
        setGridColumns(removedfields)
    }

    const handleDataStateChange = (changeEvent) => {
        setDataState(changeEvent.data)
    }
 
    const handleBack = () => {
        const { back } = props.options;
        const { routes } = back;
        if (Array.isArray(routes)) {
            let path = ''
            routes.forEach(each => {
                const { route, routeParams, matchProps } = each
                path += route + "/" + props.match.params[routeParams]
            })
            props.history.push(path)
        }
    }

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
        if (newValue === 3) {
            setHasCheckBox(true)
        }
        else {
            setHasCheckBox(false)
        }
    }

    useEffect(() => {
        //console.log('Loading from tab value change----------------------**')
        LoadExistingInvoiceData();
        setData([])
    }, [TabValue])

    //Genreate options
    const handleButtonClick = () => {
        if (TabValue === '1') {
            GenerateProrateInvoice(recordDetails);
        } else if (TabValue === '2') {
            GeneratePermitRenewalInvoice(recordDetails);
        }
    }

    const GeneratePermitRenewalInvoice = (recordDetails) => {
        GenerateInvoice(recordDetails, "PERMITRENEWAL").then(res => {
            console.log(res);
            if (res && res.Id && res.InvoiceLineItems) {
                LoadExistingInvoiceData();
            }
        }).catch(function (err) {
            console.error(err);
            let nobll = err.Error === 'NOBILLING'
            let nosetting = err.Error === 'NOSETTING'
            props.snackbarMessage(`No permit fee found in settings.`, 'info')
        })
    }

    const GenerateProrateInvoice = (recordDetails) => {
        GenerateInvoice(recordDetails, "PRORATE").then(res => {
            console.log(res);
            if (res && res.Id && res.InvoiceLineItems) {
                LoadExistingInvoiceData();
            }
        }).catch(function (err) {
            console.error(err);
            let nobll = err.Error === 'NOBILLING'
            let nosetting = err.Error === 'NOSETTING'
            props.snackbarMessage(`No prorate fee found in settings.`, 'info')
        })
    }


    useEffect(() => {
        SetGridData();
    }, [(TabValue == "0" || TabValue == "2") ? LineItemsdata : data])



    const SetGridData = () => {
        const queryStr = `${toDataSourceRequestString(dataState)}`;
        //we do request grid request and need to  append queryStr for url
        let dataitems = (TabValue == "0" || TabValue == "2") ? LineItemsdata : data || []
        //setData(dataitems);
        setTotal(dataitems.length);
        //for getting distinct columns, returns all distinct columns by verifying all objects in data array
        let columnsarr = _.union(_.flatten(_.map(dataitems, (e) => _.keys(e))));
        var removedfields = _.remove(columnsarr, function (n) {
            if (TabValue < 3)
                return n != "UpdatedBy" && n != "UpdatedOn" && n != "Id" && n != "BillingPayments" && n != "DownloadId" && n != "CreatedBy" && n != "CreatedOn";
            else
               if (getEnvVariable('ModuleKey') === 'LAOACS') {
                return n != "UpdatedBy" && n != "UpdatedOn" && n != "BillingPayments" && n != "PermitNumber" && n != "DownloadId" && n != "CreatedBy" && n != "CreatedOn" ;
               } else {
               return n != "UpdatedBy" && n != "UpdatedOn" && n != "CashControlNumber" && n != "TransactionStatus" && n != "BillingPayments" && n != "PermitNumber" && n != "DownloadId" && n != "CreatedBy" && n != "CreatedOn" ;
               }
        });
        setGridColumns(removedfields)
    }
    
    const payOnlineAll = () => {
        let routeid = props.match.params.routeid;
        let routeid1 = props.match.params.routeid1;
        let currentuser = props.accessPermissions.userId;
        let invoicecondition = ""
        let selectionmapdataid = gridCheckBoxSelectionRecords.map(res => {
            return res.Id
        })
        if (selectionmapdataid && Array.isArray(selectionmapdataid)) {
            selectionmapdataid.forEach(element => {
                if (Number.isInteger(element))
                    invoicecondition = invoicecondition + 'id=' + element + '&';
            });

            let url = getEnvVariable('PaymentGateWay') + `/OnlinePayment/Index/${routeid}/${routeid1}/${currentuser}?${invoicecondition}`  //${invoice.Id}
            let payment_window = window.open(url, 'popUpWindow', 'height=800,width=1000,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes')
            payment_window.focus();
            var timer = setInterval(function () {
                if (payment_window.closed) {
                    clearInterval(timer);
                    LoadExistingInvoiceData();
                }
            }.bind(this), 1000);
        }
    }

    const PaymentStatus = () => {
        return invoice ? (invoice.Status === 'P' ? 'Paid' : invoice.Status === 'R' ? 'Refund' : 'Unpaid') : '';
    }

    const rowRenderData = (row) => {
        let gridrow = row.dataItem;
        gridrow.InvoiceId = TabValue < 3 ? row.dataItem.InvoiceId : row.dataItem.Id
        setGridSelectionRecord(gridrow)
        // if (TabValue < 3) {
        //     setGridSelectionRecord(row.dataItem.InvoiceId)
        // } else {
        //     setGridSelectionRecord(row.dataItem.Id)
        // }
    }

    const gridSelection = (datavalues, selectionmapdata) => {
        //setData(datavalues);
        setGridCheckBoxSelectionRecords(selectionmapdata)
    }
    const gridselectionLoad = (gridcheckload) => {
        console.log(gridcheckload);
    }

    useEffect(() => {
        if (TabValue === 4 && gridSelectionRecord) {
            physicalcheckSlider(true, 'PAYMENT', gridSelectionRecord.id)
        } else if (gridSelectionRecord && gridSelectionRecord.InvoiceId > 0) {
            setOpenInvoice(true);
        }
    }, [gridSelectionRecord])

    const handleSlide = () => {
        setOpenSlide(false);
        setCurrentDataItem(null);
        LoadExistingInvoiceData();
    }

    const handleInvoiceSlider = () => {
        setOpenInvoice(false);
        setGridSelectionRecord(false);
    }

    const regenerateSlider = (type) => {
        setGenerateInvoiceType(type);
    }

    const physicalcheckSlider = (open, type, id) => {
        //setPhysicalCheck(open);
        if (!open) {
            setPhysicalCheckProps({ open: false, viewtype: '', id: 0 });
            LoadExistingInvoiceData();
        }
        else
            setPhysicalCheckProps({ open: true, viewtype: type, id: id })
    }

    const handleRegenerateSlider = (RegenerateOptions) => {
        //setGenerateInvoiceType(type);
        if (RegenerateOptions && RegenerateOptions.RegenerateType) {
            if (generateInvoiceType === "G" && RegenerateOptions.RegenerateType === "2") {
                let invoiceprops = { ...RegenerateOptions, ...recordDetails };
                if (TabValue === '1') {
                    GenerateProrateInvoice(invoiceprops);
                } else if (TabValue === '2') {
                    GeneratePermitRenewalInvoice(invoiceprops);
                }
            } else {
                let applicantid = recordDetails['COMPANY_ID'] //props.match.params.routeid2
                let sitepermittypeid = props.match.params.routeid
                let recordid = props.match.params.routeid1
                let invtype = (RegenerateOptions.RegenerateType === "1" && generateInvoiceType === "R" || (RegenerateOptions.RegenerateType === "1" && generateInvoiceType === "G")) ? "A" : "C"
                let invid = invoice.Id ? invoice.Id : '-1'
                let cancelParent = RegenerateOptions.CancelInvoice ? "Y" : "N";
                let RegenerateProps = { ...RegenerateOptions, SitePermitTypeId: sitepermittypeid, InvoiceId: invid, ApplicantId: applicantid, InvoiceType: invtype, RecordId: recordid, CancelParent: cancelParent, SubModuleKey: props.match.params.key };
                ReGenerateInvoice(RegenerateProps).then(a => {
                    console.log(a);
                    LoadExistingInvoiceData();
                    if (DefaultSettings.getAlert() != null)
                        DefaultSettings.getAlert().show(`Invoice generated successfully.`, 'success');
                    //     props.snackbarMessage(`Invoice generated successfully.`, 'success');
                }).catch(function (err) {
                    if (DefaultSettings.getAlert() != null)
                        DefaultSettings.getAlert().show(`No records found for this owner.`, 'error');
                    //console.error(err);
                    // props.snackbarMessage(`No records found for this owner.`, 'error')
                })

            }
        }
        setOpenGenerateInvoice(false);
        setGenerateInvoiceType(null);
    }

    const InvoiceStatusChange = (e) => {
        let currstatus = e.target.value;
        if (TabValue < 3) {
            if (!IsValidInvoiceStatus(invoice.Status, currstatus)) {
                props.snackbarMessage(`Invalid status change.`, 'error');
            } else {
                let inv = invoice;
                inv.Status = currstatus;
                // setInvoice(inv)
                // props.Confirmation(updateInvoiceStatusCancel, () => updateInvoiceStatus(inv), 'Are You sure you want update. This cannot be undone.', true);
            }
        } else {
            if (!IsValidPermitStatus(invoice.Status, currstatus)) {
                props.snackbarMessage(`Invalid status change.`, 'error');
            } else {
                let inv = invoice;
                inv.Status = currstatus;
                // setInvoice(inv)
            }
        }

        const updateInvoiceStatusCancel = () => {
            // props.Confirmation(null, null, null, false);
        }

        const updateInvoiceStatus = (inv) => {
            //  props.Confirmation(null, null, null, false);
            UpdateInvoiceStatus(inv.Id, inv.Status).then(res => {
                setInvoice(inv)
                props.snackbarMessage(`Updated successfully.`, 'success');
            })
        }
    }

    useEffect(() => {
        if (generateInvoiceType)
            setOpenGenerateInvoice(true)
    }, [generateInvoiceType])

    const viewInvoice = () => {
        if (invoice && invoice.Id > 0) {
            let downloadid = billingsitePermitTypeData.ApplicationInvoiceDownloadId;
            let gridselectionrecord = { InvoiceId: invoice.Id, DownloadId: downloadid, ...invoice }
            setOpenInvoice(true);
            setGridSelectionRecord(gridselectionrecord)
        }
    }

    const handleSaveClick = () => {
        console.log("click");


        const read = [
            {
                url: getEnvVariable('Payment') + `Invoice/UpdateControlNumber/` + `${invoice.Id}` + '/' + `${cashcontrolnumber}` + '/' + `${transinvoice}`,
                type: 'post'
            },


        ]
        Promise.all(read.map(each => requestApi(createRequest(each, {})))).then(response => {
            const [list1] = response;


        })


    }

    const handlecashcontrol = (evt) => {
        setcashcontrolnumber(evt.target.value);
    }

    const handletransaction = (evt) => { 
        if(cashcontrolnumber === null || cashcontrolnumber === ''){
            props.snackbarMessage(`Please enter Cash Control Number.`, 'error');
            return;
        }
        else
        {   
            setTransInvoice(evt.target.value);
            console.log(transinvoice);
            const read = [
                {
                    url: getEnvVariable('Payment') + `Invoice/UpdateControlNumber/` + `${invoice.Id}` + '/' + `${cashcontrolnumber}` + '/' + `${evt.target.value}`,
                    type: 'post'
                },
            ]
            Promise.all(read.map(each => requestApi(createRequest(each, {})))).then(response => {
                const [list1] = response;
            })
        }

    }

    const openMSBPayDailogue = (ref) => {
        setOpenMSBPay(ref)
        if(!ref){
        LoadExistingInvoiceData();
        }
      }

    const GenerateApplicationInvoice = () => {
        // //let fieldValues = { 'COMPANY_ID': 1 }
        // let routeid = params.routeid;
        let routeid1 = params.routeid1;
        // let routeid2 = recordDetails['COMPANY_ID'] || 0;
        // let key = params.key;

        // let appdata = {
        //     "COMPANY_ID": routeid2,
        //     "SITE_PERMIT_TYPE_ID": routeid,
        //     "Id": routeid1,
        //     "DISTRICT_ID": recordDetails['DISTRICT_ID'],
        //     "COUNTY": recordDetails['SITE_ID'],
        //     "KEY": key
        // };
        // GenerateInvoice(appdata, "APPLICATION").then(res => {
        //     if (DefaultSettings.getAlert() != null)
        //         DefaultSettings.getAlert().show('New invoice has been generated. Successful payment will automatically submit this application.', 'info');
        // }).catch(ex => {
        //     console.log(ex);
        // })

        let url = getEnvVariable('Payment') + `Invoice/GenerateInvoice/` + `${routeid1}`;

        GetData(url, '', true).then(resp => {
            if (resp) {
                setInvoice(resp);
                if (DefaultSettings.getAlert() != null)
                    //DefaultSettings.getAlert().show('New invoice has been generated.', 'info');
                DefaultSettings.getAlert().show('An invoice has been generated for this request.  Request approval is contingent upon the payment status.', 'info');
            }

        });
    }


    const payOnline = () => {        
        if(getEnvVariable('ModuleKey') === 'ECCO'){
            setOpenMSBPay(true);
        }else{
            RequestPayOnline(invoice.Id).then(res => {
                if(res && res.htmL5RedirectUrl){
                    payOnlineRequester(res.htmL5RedirectUrl)
                }
            })
        }        
    }

    const payOnlineRequester = (url) => {        
        let payment_window = window.open(url, 'popUpWindow', 'height=800,width=1400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes')
        payment_window.focus();
        var timer = setInterval(function () {
            if (payment_window.closed) {
                clearInterval(timer);
                LoadExistingInvoiceData();
            }else{
                try {
                    if (payment_window?.location?.href && payment_window.location.href !== url) {
                        console.log('URL changed:', payment_window.location.href);
                        payment_window.close();
                        DefaultSettings.getAlert().show('Payment successful.', 'info');
                        //url = payment_window.location.href;
                    }
                } catch (e) {
                    // Can't access URL, not same domain
                }
            }
        }.bind(this), 2000);
    }

    const lable_baseCAP = recordDetails["KEY"] === 'VIOLATIONS' ? "Fine" : "Invoice";
    const lable_base = recordDetails["KEY"] === 'VIOLATIONS' ? "fine" : "invoice";
    const lable_allinvoices = recordDetails["KEY"] === 'VIOLATIONS' ? "All Fines" : "All Permit Invoices";

    const getGrid = (gridColumns) => {

        let stagedetails = localStorage.getItem('stagedetails')
        let profile = JSON.parse(localStorage.getItem('profile'))
        let IsAdmin = profile.isAdmin;
        let progressstatus = localStorage.getItem('permitstatus')
        let prorateinfoval = localStorage.getItem('prorateinfo')
        let showbutton = (stagedetails === "InProgress" || progressstatus === "10143") ? true : false;
        let calTotalFee = (invoice && invoice.Id) ? GetTotalFee(invoice) : 0;
        let calTotalDue = (invoice && invoice.Id) ? GetTotalDue(invoice) : 0;
        let generatebutton = stagedetails && stagedetails === "Approved" ? true : false;
        let showbutton_fine = (recordDetails["KEY"] === 'VIOLATIONS');

        return (
            <div className="row h-100 mx-1">
                <AppBar position='static' color="white" className='col-sm-12' si>
                    <Tabs
                        // orientation="vertical"
                        value={TabValue}
                        onChange={handleChange}
                        style={{ color: 'black' }}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        scrollButtons="on"
                        aria-label="scrollable auto tabs example"
                    >
                        {billingsitePermitTypeData && billingsitePermitTypeData.HasApplicationFee && billingsitePermitTypeData.HasApplicationFee === "Y"
                            && <Tab classes={{
                                wrapper: classes.iconLabelWrapper,
                                labelContainer: classes.labelContainer
                            }} label="Current Invoice" icon={<AttachMoneyIcon className='mx-1' />} {...a11yProps(0)} value="0" />}
                        {billingsitePermitTypeData && billingsitePermitTypeData.HasPorate && billingsitePermitTypeData.HasPorate === "Y"
                            && <Tab classes={{
                                wrapper: classes.iconLabelWrapper,
                                labelContainer: classes.labelContainer
                            }} label="Prorate Fee" icon={<LocalAtmIcon className='mx-1' />} {...a11yProps(0)} value="1" />}
                        {billingsitePermitTypeData && billingsitePermitTypeData.PermitRenewal && billingsitePermitTypeData.PermitRenewal === "Y"
                            && <Tab classes={{
                                wrapper: classes.iconLabelWrapper,
                                labelContainer: classes.labelContainer
                            }}
                                label={lable_renewallable} icon={<MonetizationOnIcon className='mx-1' />} {...a11yProps(0)} value="2" />}
                        <Tab classes={{
                            wrapper: classes.iconLabelWrapper,
                            labelContainer: classes.labelContainer
                        }} label={lable_allrenewal} icon={<PaymentIcon className='mx-1' />} {...a11yProps(0)} value="3" />
                        <Tab classes={{
                            wrapper: classes.iconLabelWrapper,
                            labelContainer: classes.labelContainer
                        }} label={lable_paymentinformation} icon={<AccountBalanceWalletIcon className='mx-1' />} {...a11yProps(0)} value="4" />
                        {/* <Tab label="Invoice Dashboard" icon={<AssessmentIcon />} {...a11yProps(0)} value="5" /> */}
                    </Tabs>
                </AppBar>
                <div className='col-12 my-1 p-0 mx-0'>
                    <Card >
                        {/* {TabValue === 5  && 
                    <BillingDashboard/>
					}           */}
                        {TabValue < 3 &&
                            <div>
                                <div className='row' >
                                <Typography className="float-end col-5" gutterBottom><b>Invoice Id</b> <span style={{ "paddingLeft": "126px" }}>:  {(invoice && invoice.Id) ? invoice.Id : <span style={{ "color": "red" }}>Not Generated Yet</span>}</span></Typography>
                                {TabValue === 0 || TabValue === '0'  ?
                                (<Typography className="float-end col-6" gutterBottom><b>Application Fee</b><span style={{ "paddingLeft": "70px" }}>:  $ {calTotalFee}</span></Typography>) :
                                <Typography className="float-end col-6" gutterBottom><b>Permit Renewal Fee</b><span style={{ "paddingLeft": "41px" }}>:  $ {calTotalFee}</span></Typography>}
                                </div >
                                <div className='row'>
                                {TabValue === 0 || TabValue === '0'  ?
                                    (<Typography className="col-5" gutterBottom><b>Record Id</b> <span style={{ "paddingLeft": "127px" }}>:  {recordDetails && recordDetails["Id"]} </span></Typography>) : 
                                    (<Typography className="col-5" gutterBottom><b>Permit Number</b> <span style={{ "paddingLeft": "85px" }}>:  {recordDetails && recordDetails["PERMIT_NO"]} </span></Typography>)}
                                    <Typography className="col-6" gutterBottom><b>Applicant Name</b>  <span style={{ "paddingLeft": "62px" }}>:  {recordDetails && recordDetails["OWNER_NAME"]}</span></Typography>
                                    
                                </div>
                                <div className='row'>
                                    <Typography className="col-5" gutterBottom><b >{lable_baseCAP} Date</b>  <span style={{ "paddingLeft": "107px" }}>:  {(invoice && invoice.InvoiceDate) ? moment(invoice.InvoiceDate).format('MM/DD/YYYY') : 'N/A'} </span></Typography>
                                    {(TabValue <= 2 || (props.accessPermissions && props.accessPermissions.portal === "E")) && <Typography className="float-end col-6" gutterBottom><b>{lable_baseCAP} Status</b> <span style={{ "paddingLeft": "78px" }}>:  {PaymentStatus()}</span> </Typography>}

                                </div>
                                <div className='row'>
                                    {TabValue <= 2 && getEnvVariable('ModuleKey') === 'LAOACS' ? <Typography className="col-5" gutterBottom><b>{lable_baseCAP} Due Date</b> <span style={{ "paddingLeft": "75px" }}>:  {(invoice && invoice.DueDate) ? moment(invoice.DueDate).format('MM/DD/YYYY') : 'N/A'} </span></Typography> : 
                                    <Typography className="col-5" gutterBottom><b >Due Upon Receipt Date</b> <span style={{ "paddingLeft": "32px" }}>:  {(invoice && invoice.Status === 'P') ? moment(invoice.UpdatedOn).format('MM/DD/YYYY') : 'N/A'} </span></Typography>}
                                    <Typography className={TabValue > 2 ? "col-6" : "float-end col-6"} gutterBottom><b>Payment Confirmation</b> <span style={{ "paddingLeft": "17px" }}>: {invoice && invoice.PaymentReference && invoice.PaymentReference != "" ? invoice.PaymentReference : 'N/A'}</span></Typography>
                                </div>

                                <div className='row'>
                                    <Typography className="col-5" style={{ "color": "red" }} gutterBottom><b>Due Amount</b>  <span style={{ "paddingLeft": "105px" }}>: $ {calTotalDue}</span></Typography>
                                    <Typography className="float-end col-6 " gutterBottom><b >Amount Paid</b> <span style={{ "paddingLeft": "84px" }}>: $ {parseFloat(calTotalFee - calTotalDue).toFixed(2)}</span></Typography>
                                </div>
                                <div className='row'>
                                    <Typography className="col-5" gutterBottom> </Typography>   
                                    {TabValue <= 2 && getEnvVariable('ModuleKey') === 'LAOACS' ? <Typography className="col-5" gutterBottom><b >Payment Date</b> <span style={{ "paddingLeft": "77px" }}>:  {(invoice && invoice.Status === 'P') ? moment(invoice.BillingPayments[0].BillingPaymentDetails.TransactionDate).format('MM/DD/YYYY') : 'N/A'} </span></Typography> : 'N/A'}
                                </div>
                                {getEnvVariable('ModuleKey') === 'LAOACS' ?  (<div className='mb-2 border'>
                                    <div className='row'>
                                        {invoice.Status === 'P' &&  <div className='col-5'><TextBox name='CASH_CONTROL_NUMBER' label="Cash Control Number" tooltip='Please Enter Cash Control Number' placeholder='' type='textfield' disabled={getEnvVariable('AccessPortal') === 'E'} value={cashcontrolnumber} handleFieldValue={(e) => handlecashcontrol(e)} /></div>
                                        }
                                        
                                        {invoice.Status == 'P' && transinvoiceitems.length > 0 && <div className='col-5'><Dropdown extraProps={{ transformProps: { label: "Name", value: "Value" } }} items={transinvoiceitems || []} handleFieldValue={(e) => handletransaction(e)} value={transinvoice} label='Transaction Status' name='TRANSCATION_STATUS' disabled={getEnvVariable('AccessPortal') === 'E' || cashcontrolnumber === null}/></div>
                                        }
                                        {invoice.Status == 'P' && <div className='col-2'><Button style={{ "width": "60px", height: "45px" }} className=" col-1" onClick={handleSaveClick} disabled={!(cashcontrolnumber && transinvoice) || transinvoice === "C" || getEnvVariable('AccessPortal') === 'E'}><SaveIcon /> </Button></div>
                                        }
                                    </div>
                                </div>) : ('')}
                                {TabValue > 1 && (props.accessPermissions && props.accessPermissions.portal != "E") && <Typography align="right" className="float-end pr-3" gutterBottom><b>{lable_baseCAP} Status</b> :<Select onChange={(e) => InvoiceStatusChange(e)} value={invoice && invoice.Status ? ((invoice.Status == 'R' || invoice.Status == 'U') ? 'U' : invoice.Status) : ''} >
                                    {paymentStatusOptions && paymentStatusOptions.length > 0 && paymentStatusOptions.map((opt, index) => {
                                        return <MenuItem key={index} value={opt.Value}>{opt.Name}</MenuItem>
                                    })}
                                </Select> </Typography>}

                                {TabValue > 2 && <Typography className="pl-3" gutterBottom><b>{lable_baseCAP} Due Date:2</b> {(invoice && invoice.DueDate) ? moment(invoice.DueDate).format('MM/DD/YYYY') : 'N/A'} </Typography>}



                            </div>}
                        {/*{TabValue == 3 && <div>
                            <Typography className="pl-3 pt-2" gutterBottom><b>{lable_allinvoices}</b></Typography>
                            <Typography className="pl-3 pt-2" gutterBottom><b>Multiple unpaid {lable_base}s can be paid online. Maximum selection limited to 50 {lable_base}.</b></Typography>
                        </div>} */}
                        {TabValue === 4 && <div>
                            <Typography className="pl-3 pt-2" gutterBottom><b>All {lable_base} payment information</b></Typography>
                        </div>}
                        {/* <hr style={{height:'2px' ,padding:'0', color:'gray' , backgroundColor:'gray'}} ></hr> */}

                        {TabValue != 5 &&

                            <BillingGrid data={(TabValue == "0" || TabValue == "2") ? LineItemsdata:data} total={total} gridSelection={gridSelection} gridselectionLoad={gridselectionLoad} hascheckbox={hascheckbox} rowRenderData={rowRenderData} gridColumns={gridColumns} sidebar={true} /> 
                        }

                        {TabValue === 3 && <div>
                            <Typography display="block" color="secondary" className="pl-3 pt-2" gutterBottom><b>Note: Partial payment {lable_base}s can only be paid from payment information section.</b></Typography>
                        </div>}
                        <div className="col-sm-12 pt-3">
                            <InvoiceSideBar ref={helpContext} open={openInvoice} gridrow={gridSelectionRecord} handleInvoiceSlider={handleInvoiceSlider} />

                            <RegenerateSideBar ref={silderContext} open={openGenerateInvoice} type={generateInvoiceType} invoiceid={invoice ? invoice.Id : -1} handleRegenerateSlider={handleRegenerateSlider} recordDetails={recordDetails} />

                            {physicalCheckProps.open && <PhysicalCheckSideBar open={physicalCheckProps.open}
                                invoiceid={(invoice && invoice.Id) ? invoice.Id : ((gridSelectionRecord && gridSelectionRecord.invoices) ? gridSelectionRecord.invoices : 0)}
                                viewtype={physicalCheckProps.viewtype}
                                billingid={physicalCheckProps.id}
                                appdata={recordDetails}
                                physicalcheckSlider={physicalcheckSlider}
                                recorddata={gridSelectionRecord} {...props} />}

                            {/*{showbutton && getEnvVariable('AccessPortal') === 'I' && TabValue === '1' && !invoice.Id && recordDetails && recordDetails["EXEMPTED_FROM_PRORATE"] === "N" && <Button className="col-sm-2 float-end pr-2" variant="contained" color="primary" onClick={handleButtonClick}>Generate</Button>}

                            Following button specific for violation fines
                            {showbutton_fine && getEnvVariable('AccessPortal') === 'I' && TabValue === '2' && recordDetails && <Button className="col-sm-3 float-end pr-2" variant="contained" color="primary" onClick={() => regenerateSlider("G")}>Generate</Button>}

                            {!showbutton_fine && getEnvVariable('AccessPortal') === 'I' && TabValue === '2' && invoice && invoice.Id && <Button className="col-sm-2 float-end p-2" variant="contained" color="primary" onClick={() => regenerateSlider("R")}>Regenerate {lable_baseCAP}</Button>}*/}

                            {getEnvVariable('AccessPortal') === 'I' && IsAdmin === 'Y' && TabValue === '0' && <Button className="col-sm-3 float-end pr-2 m-1" variant="contained" color="primary" onClick={() => GenerateApplicationInvoice()}>Generate</Button>}

                            {/*{generatebutton && getEnvVariable('AccessPortal') === 'I' && TabValue === '2' && recordDetails && recordDetails["EXEMPTED_FROM_RENEWAL"] === "N" && <Button className="col-sm-2 float-end pr-2" variant="contained" color="primary" onClick={() => regenerateSlider("G")}>Generate</Button>}
                            */}
                            
                            {invoice && invoice.Id && invoice.Status === 'U' && TabValue != '3' && <Button className="col-sm-3 float-end pr-2 m-1" variant="contained" color="primary" onClick={payOnline}>Pay Online</Button>} 
                            {openMSBPay && <MSBCheckout open={true} setOpen = {() => openMSBPayDailogue(false)} invoice={invoice} />}

                            {getEnvVariable('AccessPortal') === 'I' && invoice && invoice.Id && invoice.Id > 0 && TabValue < 3 && <Button className="col-sm-3 float-end pr-2 m-1" variant="contained" color="primary" onClick={() => physicalcheckSlider(true, 'INVOICE', invoice.Id)}>Physical Check </Button>}

                            {TabValue === '3' && gridCheckBoxSelectionRecords.length > 0 && <Button className="col-sm-2 float-end pr-2" variant="contained" color="primary" onClick={payOnlineAll}>Pay Online(Selected)</Button>}

                            {invoice && invoice.Id && invoice.Id > 0 && TabValue < 3 && <Button className="col-sm-2 float-end pr-2 m-1" variant="contained" color="primary" onClick={viewInvoice}>View {lable_baseCAP}</Button>}
                            {/* <Button className="col-sm-2 float-end pr-2" variant="contained" color="primary" onClick={DownloadInvoicePDF}>Download</Button> */}
                        </div>
                        <div>
                            {pdf && <iframe src={pdf} width="100%" height="100%" frameborder="0" scrolling="no" id="iframe" />}
                        </div>
                    </Card>
                </div>

            </div>
        )
    }

    const lable_renewallable = recordDetails["KEY"] === 'VIOLATIONS' ? "Latest Fine Record" : "Current Renewal Invoice";
    const lable_allrenewal = recordDetails["KEY"] === 'VIOLATIONS' ? "All Fines" : "All Invoices";
    const lable_paymentinformation = recordDetails["KEY"] === 'VIOLATIONS' ? "Fine Payment Information" : "Invoice Payment Information";
    return (
        <div >
            {/* {headerProps &&
                <GridHeader initialloadextrainfo={initialloadextrainfo} headerProps={headerProps} compmap={props.compmap} accessPermissions={props.accessPermissions} accessLevelPermissions={props.accessLevelPermissions} handleBack={handleBack} />} */}

            {/* <Tabs
                    orientation="vertical"
                    className='col-2'
                    value={TabValue}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    scrollButtons="on"
                    aria-label="scrollable auto tabs example"
                >
                    {sitePermitTypeData && sitePermitTypeData.HasApplicationFee && sitePermitTypeData.HasApplicationFee === "Y"
                        && <Tab label="Application Fee 1" style={{width:'100%' }}icon={<AttachMoneyIcon />} {...a11yProps(0)} value="0" />}
                    {sitePermitTypeData && sitePermitTypeData.HasPorate && sitePermitTypeData.HasPorate === "Y"
                        && <Tab label="Prorate Fee" icon={<LocalAtmIcon />} {...a11yProps(0)} value="1" />}
                    {sitePermitTypeData && sitePermitTypeData.PermitRenewal && sitePermitTypeData.PermitRenewal === "Y"
                        && <Tab label={lable_renewallable} icon={<MonetizationOnIcon />} {...a11yProps(0)} value="2" />}
                    <Tab label={lable_allrenewal} icon={<PaymentIcon />} {...a11yProps(0)} value="3" />
                    <Tab label={lable_paymentinformation} icon={<AccountBalanceWalletIcon />} {...a11yProps(0)} value="4" />
                </Tabs> */}

            {getGrid(gridColumns)}
        </div>
    )
}

const mapProps = (state) => {
    return state
}

const mapActions = dispatch => {
    return bindActionCreators({ snackbarMessage }, dispatch);
}

Billing = connect(mapProps, mapActions)(Billing)
export default withRouter(Billing)